module.exports = __webpack_public_path__ + "static/media/23.4b03c3e0.jpg";